module.exports = __webpack_public_path__ + "img/chevron_blue_up.92d9c05.svg";